import * as Dtos from "../../../../dtos/Tmd.dtos";
import classNames from "classnames";
import * as React from "react";
import { FieldAction } from "react-redux-form";
import CollectionInstanceTrackerPageContainer from "../../../../containers/Collection/CollectionInstanceTracker/CollectionInstanceTrackerPage";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../../constants/fontAwesomeIcons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import "./CustomFormInput.scss";

export interface ICustomFormInputProps {
    item?: Dtos.ItemComponent;
    feedbackIcon?: IconDefinition;
    className?: string;
    label?: string;
    name: string;
    id: string;
    // onChange?: (value: any, options?: ChangeOptions) => ModelAction;
    onFocus?: () => FieldAction;
    validationFailures?: Dtos.ResponseError[];
    // value: any;
    disabled?: boolean;
    focused?: boolean;
    valid?: boolean;
    invalid?: boolean;
    hasSoftError?: boolean;
    hasHardError?: boolean;
}

class CustomFormInput extends React.PureComponent<ICustomFormInputProps, any> {
    renderComponentContainer() {}

    render() {
        const {
            className,
            item,
            disabled,
            focused,
            id,
            invalid,
            label,
            name,
            onFocus,
            valid,
            feedbackIcon,
            hasSoftError,
            hasHardError,
        } = this.props;

        const derivedClass = className ? className : "form-control";

        let primitive;

        switch (item.customInputControlName) {
            case "CustomTracking":
                primitive = <CollectionInstanceTrackerPageContainer />;
                break;
            case "CustomDivider":
                primitive = <hr />;
                break;
        }

        const hardFeedback =
            hasHardError && !disabled ? (
                <span
                    className={classNames("form-control-feedback block pr-2")}
                >
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        const feedback =
            invalid && !disabled && !hasHardError ? (
                <span className={classNames("form-control-feedback pr-2")}>
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        const softFeedback =
            hasSoftError && !disabled && !invalid ? (
                <span
                    className={classNames("form-control-feedback warning pr-2")}
                >
                    <FontAwesomeIcon
                        icon={
                            feedbackIcon
                                ? feedbackIcon
                                : FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE
                        }
                        fixedWidth
                    />
                </span>
            ) : null;

        return (
            <div style={{ display: "block" }}>
                <div style={{ width: "100%" }}>
                    {primitive}
                    {invalid && !disabled && (
                        <>
                            {hardFeedback}
                            {softFeedback}
                        </>
                    )}
                    {feedback}
                </div>
            </div>
        );
    }
}

export default CustomFormInput;
